<!--
 * @Description: 业务申请
 * @Autor: yd
 * @Date: 2020-07-27 10:37:42
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-28 13:12:14
-->
<template>
  <mrc_ess_skeleton_loader :loading="$store.state.uuid ? skeletonloading : false">
    <v-card>
      <v-card-text>
        <v-col cols="12" v-if="$store.state.uuid">
          <mrc_ess_switch
            :true-value="1"
            :false-value="0"
            :readonly="disabled"
            v-model="list.is_used"
            :true-text="$t('label_To_enable_the')"
            :false-text="$t('label_disable')"
          ></mrc_ess_switch>
        </v-col>
        <v-col cols="12">
          <!-- 员工 -->
          <!-- <mrc_ess_staffInfo
            v-model="list.on_behalf_staff_uuid"
            :readonly="disabled"
            defaultRequest
            filter="1,2,3,5"
            :notfilter="editedItem.on_behalf_staff_uuid"
            :error-messages="
              $errors('list', 'on_behalf_staff_uuid', requiredRule)
            "
            :label="$t('label_The_acting_employee') + '*'"
          >
          </mrc_ess_staffInfo> -->
          <mrc_ess_staffInfo
            v-model="list.on_behalf_staff_uuid"
            itemValue="user_id"
            :multiple="true"
            :readonly="disabled"
            :dropDownList="list_on_behalf_staff_uuid_arr"
            :error-messages="$errors('list', 'on_behalf_staff_uuid', requiredRule)"
            :label="$t('label_The_acting_employee') + '*'"
          ></mrc_ess_staffInfo>
        </v-col>
        <v-col cols="12" class="d-flex">
          <mrc_ess_datePicker
            @getTime="paramsChange"
            :disabled="disabled"
            afterDate
            :errMsg="
              $errors(
                'list',
                'effective_utc_start_date',
                requiredRule.concat([
                  {
                    rule: 'beforeDate',
                    msg: $t('verify_cannot_exceed_the_expiration_date'),
                  },
                ])
              )
            "
            :label="$t('label_Start_date') + '*'"
            v-model="list.effective_utc_start_date"
          ></mrc_ess_datePicker>
          <div class="px-2 d-flex" style="font-size: 28px; align-items: center">
            <v-icon class="material-icons">arrow_forward_ios</v-icon>
          </div>
          <mrc_ess_datePicker
            @getTime="paramsChange"
            :label="$t('label_End_date') + '*'"
            :disabled="disabled"
            :errMsg="
              $errors(
                'list',
                'effective_utc_end_date',
                requiredRule.concat([
                  {
                    rule: 'afterDate',
                    msg: $t('verify_no_later_than_the_start_time'),
                  },
                ])
              )
            "
            v-model="list.effective_utc_end_date"
          ></mrc_ess_datePicker>
        </v-col>
        <v-col cols="12">
          <mrc_ess_multiText
            :label="$t('label_Agency_reason')"
            v-model="list.onbehalf_reason"
            :error-messages="$errors('list', 'onbehalf_reason', nocharacter)"
            noRequired
            :readonly="disabled"
          ></mrc_ess_multiText>
        </v-col>
        <v-col cols="12">
          <v-checkbox
            class="mx-2"
            :true-value="1"
            :false-value="0"
            :readonly="disabled"
            v-model="list.is_feedback"
            :label="$t('label_Feedback')"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" class="tableBoxComponent">
          <v-data-table
            :headers="showHeaders"
            :items="items"
            sort-by="calories"
            hide-default-footer
          >
            <template v-slot:no-data>
              <mrc_ess_noContent :no_data_text="$t('label_blank')" />
            </template>
            <template #item.function_uuid="{ item }">
              <mrc_ess_prompt
                v-model="item.function_uuid"
                view
                obj="level_functions"
              ></mrc_ess_prompt>
            </template>

            <template #item.button_uuid="{ item }">
              <mrc_ess_prompt
                v-model="item.button_uuid"
                view
                :obj="cs(item)"
              ></mrc_ess_prompt>
            </template>

            <template #item.on_behalf_staff_uuid="{ item }">
              <div
                v-for="(item1, index) in item.on_behalf_staff_uuid"
                :style="{
                  'border-bottom':
                    index > 0 && index < item.on_behalf_staff_uuid.length - 1
                      ? '1px dashed #E0E0E0'
                      : '',
                }"
                :key="index"
              >
                <mrc_ess_staffListView
                  :staffuuid="item1"
                  itemValue="user_id"
                  :allList="allList"
                ></mrc_ess_staffListView>
              </div>
            </template>

            <template v-slot:item.actions="{ item }" v-if="!disabled">
              <v-icon @click="editItem(item)" class="mr-2">mdi-pencil</v-icon>
              <v-icon @click="deleteItem(item)">mdi-delete</v-icon>
            </template>

            <template v-slot:footer>
              <v-divider></v-divider>
              <!-- <span v-if="!disabled"
                    class="mt-2 pb-2 d-flex ml-5"
                    @click="editItem">
                <span :style="{
                    color: $vuetify.theme.defaults.light.primary,
                    lineHeight: '28px',
                    fontSize: '12px',
                  }">{{ $t('label_New_business_function') }}</span>
                <v-icon class="material-icons"
                        :style="{
                    color: $vuetify.theme.defaults.light.primary,
                    fontSize: '24px',
                  }">add</v-icon>
              </span> -->

              <mrc_ess_textAddBtn
                @click="editItem"
                v-if="!disabled"
                :rounded="false"
                :text="$t('label_New_business_function')"
                depressed
              ></mrc_ess_textAddBtn>
            </template>
          </v-data-table>
        </v-col>
        <!-- 业务功能弹出框 -->
        <mrc_ess_myDialog
          v-model="dialog"
          :title="$t('label_New_business_function')"
          width="680"
          @success="save"
          @cancel="close"
        >
          <v-row>
            <v-col cols="12">
              <!-- 代理人 -->
              <!-- <mrc_ess_staffInfo
                v-model="editedItem.on_behalf_staff_uuid"
                :multiple="true"
                defaultRequest
                filter="1,2,3,5"
                :notfilter="editedItem.on_behalf_staff_uuid"
                :readonly="disabled"
                :errorMessages="
                  $errors('editedItem', 'on_behalf_staff_uuid', requiredRule)
                "
                :label="$t('label_agent') + '*'"
              ></mrc_ess_staffInfo> -->
              <mrc_ess_staffInfo
                v-model="editedItem.on_behalf_staff_uuid"
                :dropDownList="apply_staff_uuid_arr"
                itemValue="user_id"
                :multiple="false"
                :readonly="disabled"
                :errorMessages="
                  $errors('editedItem', 'on_behalf_staff_uuid', requiredRule)
                "
                :label="$t('label_agent') + '*'"
              ></mrc_ess_staffInfo>
            </v-col>
            <v-col cols="12">
              <!-- @getData="getData" -->
              <mrc_ess_prompt
                :rules="false"
                :errMsg="$errors('editedItem', 'function_uuid', requiredRule)"
                v-model="editedItem.function_uuid"
                :label="$t('label_Business_functions') + '*'"
                :disabled="disabled"
                :select_arr="functionType"
              ></mrc_ess_prompt>
            </v-col>
            <!-- <v-col cols="12">
              <mrc_ess_prompt :rules="false"
                              :errMsg="$errors('editedItem', 'button_uuid', requiredRule)"
                              v-model="editedItem.button_uuid"
                              :label="$t('label_Business_button') + '*'"
                              :disabled="disabled"
                              :obj="button_uuid">
              </mrc_ess_prompt>
            </v-col> -->
          </v-row>
        </mrc_ess_myDialog>
      </v-card-text>
      <mrc_ess_submitBtn
        @success="success"
        @cancel="cancel"
        :loading="btnIsLoading"
        v-if="!disabled"
      ></mrc_ess_submitBtn>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import { getStaffListForFilter } from "@/service/api/autoComplete.js";
import { getBusinessList } from "@/service/api/prompt";
import {
  getBusinessApplyList,
  addBusinessApply,
  updateBusinessApply,
  deleteBusinessApply,
  detailBusinessApply,
} from "@/service/api/businessApply.js";
import { required, maxLength, between, email, url } from "vuelidate/lib/validators";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      allList: [],
      skeletonloading: true,
      dialog: false,
      list: {
        is_used: 1,
        is_feedback: 0,
        org_level_uuid: this.$store.state.currentCompany,
      },
      btnIsLoading: false,
      viewList: {},
      blanklist: [], //新业务列表
      deleteblanklist: [], //删除列表
      editedIndex: -1,
      editedItem: {
        on_behalf_staff_uuid: "",
        function_uuid: "",
        // button_uuid: '',
      },
      defaultItem: {
        on_behalf_staff_uuid: "",
        function_uuid: "",
        // button_uuid: '',
      },
      list_on_behalf_staff_uuid_arr: [],
      apply_staff_uuid_arr: [],
      functionType: [],
    };
  },
  computed: {
    button_uuid() {
      return {
        prompt_name: "level_buttons",
        function_uuid: this.editedItem.function_uuid,
      };
    },
    company_uuid() {
      //当前选中公司uuid
      return this.$store.state.currentCompany;
    },
    // turnover_person () {
    //   return { prompt_name: 'turnover_person' }
    // },
    showHeaders() {
      return this.headers;
    },
    headers() {
      let arr = [
        {
          text: this.$t("label_Business_functions"),
          align: "start",
          sortable: false,
          value: "function_uuid",
        },
        // {
        //   text: this.$t('label_button'),
        //   align: 'start',
        //   sortable: false,
        //   value: 'button_uuid',
        // },
        {
          text: this.$t("label_agent"),
          align: "start",
          sortable: false,
          value: "on_behalf_staff_uuid",
        },
      ];
      if (!this.disabled && arr[arr.length - 1].value != "actions") {
        arr.push({
          align: "end",
          sortable: false,
          value: "actions",
        });
      }
      return arr;
    },
    items() {
      let arr = this.$clone(this.blanklist) || [];
      arr.forEach((item) => {
        item.on_behalf_staff_uuid =
          String(item.on_behalf_staff_uuid).indexOf(",") != -1
            ? item.on_behalf_staff_uuid.split(",")
            : [item.on_behalf_staff_uuid];
      });
      return arr;
    },
    // 员工需要的代理员工的uuid作为参数
    list_on_behalf_staff_uuid_arr_uuid() {
      let str = [];
      this.blanklist.forEach((item) => {
        str = str.concat(item.on_behalf_staff_uuid.split(","));
      });
      return str.join(",");
    },
    not_function_uuid() {
      let str = "";
      this.blanklist.forEach((item, index) => {
        str += item.function_uuid + ",";
        if (index + 1 == this.blanklist.length) {
          str = str.slice(0, -1);
        }
      });

      return str;
    },
  },
  created() {
    this.getdropDownList();
  },
  watch: {
    disabled: {
      handler(v) {
        if (!this.$store.state.uuid) return;
        if (!v) {
          this.$route.meta.title = "label_edit_application_agent";
          this.$store.commit("set_page_title", "label_edit_application_agent");
        } else {
          this.$route.meta.title = "label_view_application_agent";
          this.$store.commit("set_page_title", "label_view_application_agent");
        }
      },
      immediate: true,
    },
    async list_on_behalf_staff_uuid_arr_uuid(val) {
      await this.getStaffList(
        val,
        "list_on_behalf_staff_uuid_arr",
        this.list.on_behalf_staff_uuid
      );
    },

    async dialog(val) {
      if (val) {
        await this.getFunctionType();
        await this.getStaffList(
          this.list.on_behalf_staff_uuid,
          "apply_staff_uuid_arr",
          this.editedItem.on_behalf_staff_uuid
        );
      }
    },
  },
  async mounted() {
    this.national("mrbase_sys_apply_on_behalf");
    if (this.$store.state.uuid) {
      await this.getDetail();
    } else {
    }
    await this.getStaffList(
      this.list_on_behalf_staff_uuid_arr_uuid,
      "list_on_behalf_staff_uuid_arr",
      this.list.on_behalf_staff_uuid
    );
    // await this.getStaffList(
    //   this.list.on_behalf_staff_uuid,
    //   "apply_staff_uuid_arr"
    // )
    await this.getFunctionType();
  },
  methods: {
    async getFunctionType() {
      const res = await getBusinessList({
        prompt_name: "level_functions",
        not_uuid: this.not_function_uuid,
        this_uuid: this.editedItem.function_uuid,
      });
      if (res.code == 200) {
        this.functionType = res.data;
      }
    },
    async getStaffList(notfilter, attr, value) {
      const res = await getStaffListForFilter({
        value,
        filter: "1,2,3,5",
        org_level_uuid: this.$store.state.currentCompany,
        // notfilter: notfilter,
        notUser: notfilter,
      });
      if (res.code == 200) {
        if (Array.isArray(res.data) && res.data.length > 0) {
          this[attr] = res.data.concat([]);
        } else {
          this[attr] = [];
        }
      }
    },
    async getdropDownList() {
      const res = await getStaffListForFilter({
        org_level_uuid: this.$store.state.currentCompany,
      });
      if (res.code == 200) {
        this.allList = res.data;
      }
    },
    getData(v) {
      this.editedItem.button_uuid = "";
    },
    cs(item) {
      return {
        prompt_name: "level_buttons",
        function_uuid: item.function_uuid,
      };
    },
    selectItem(item) {
      this.uuid = item.uuid;
      this.uuidlist.push(item);
    },
    paramsChange() {},
    changeList(val) {
      this.viewList = val;
    },
    async getDetail() {
      this.skeletonloading = true;
      const res = await detailBusinessApply({ uuid: this.$store.state.uuid });
      if (res.code == 200) {
        this.list = res.data;
        this.blanklist = res.mrbase_sys_apply_on_behalf_details;
        // this.blanklist = res.mrbase_sys_apply_on_behalf_details.map(item => {
        //   item.on_behalf_staff_uuid = String(item.on_behalf_staff_uuid).indexOf(',') != -1 ? item.on_behalf_staff_uuid.split(',') : [item.on_behalf_staff_uuid]
        //   return item
        // })
      } else {
      }
      this.skeletonloading = false;
    },
    async success() {
      this.$v.list.$touch();
      if (this.$v.list.$error) return;
      if (this.items.length <= 0)
        return this.$Message({
          text: this.$t("message_business_function_contains_at_least_one"),
          color: "rgba(0, 0, 0, 0.78)",
        });
      this.btnIsLoading = true;
      let mrbase_sys_apply_on_behalf_details = this.blanklist;
      // const mrbase_sys_apply_on_behalf_details = this.blanklist.map(item => {
      //   item.on_behalf_staff_uuid.join()
      //   return { ...item, on_behalf_staff_uuid: item.on_behalf_staff_uuid.join() }
      // })
      if (this.$store.state.uuid) {
        updateBusinessApply({
          ...this.$deletefield(null, this.list),
          mrbase_sys_apply_on_behalf_details: [
            ...mrbase_sys_apply_on_behalf_details,
            ...this.deleteblanklist,
          ],
          org_level_uuid: this.$store.state.currentCompany,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message({
              text: this.$t("message_The_operation_was_successful"),
            });
            this.getDetail();
            this.$emit("changeReadonly");
          }
        });
      } else {
        addBusinessApply({
          ...this.list,
          mrbase_sys_apply_on_behalf_details,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message({ text: this.$t("message_added_successfully") });
            this.$router.push({ name: "businessApply" });
          }
        });
      }
      this.btnIsLoading = false;
    },
    async cancel() {
      if (this.$store.state.uuid) {
        this.getDetail();
        this.$emit("changeReadonly");
      } else {
        this.$myConfirm({
          content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
        })
          .then((res) => {
            this.$router.push({
              name: "businessApply",
            });
          })
          .catch((err) => {});
      }
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      //银行弹出框保存
      this.$v.editedItem.$touch();
      if (this.$v.editedItem.$error) return;
      if (this.editedIndex > -1) {
        Object.assign(this.blanklist[this.editedIndex], this.editedItem);
      } else {
        let obj = this.$clone(this.editedItem);
        // obj.on_behalf_staff_uuid.indexOf(',') == -1 ? obj.on_behalf_staff_uuid = [obj.on_behalf_staff_uuid] : obj.on_behalf_staff_uuid = obj.on_behalf_staff_uuid.split(',')
        this.blanklist.push(obj);
      }
      this.close();
    },
    editItem(item) {
      //传了item就是修改  没传就是添加  默认传了事件对象。。
      this.$v.editedItem.$reset();
      if (item.on_behalf_staff_uuid) {
        // console.log(this.blanklist, this.items.indexOf(item));
        this.editedIndex = this.items.indexOf(item);
        this.editedItem = Object.assign({}, this.blanklist[this.editedIndex]);
      }
      this.dialog = true;
    },
    deleteItem(item) {
      const index = this.items.indexOf(item);
      const dd = this.blanklist.splice(index, 1);
      if (dd[0].uuid || dd[0].staff_uuid)
        this.deleteblanklist.push({ ...dd[0], "~type~": "del" });
    },
  },
  validations: {
    list: {
      on_behalf_staff_uuid: {
        required,
      },
      onbehalf_reason: {
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      effective_utc_start_date: {
        required,
        beforeDate(value) {
          if (!this.list.effective_utc_end_date) return true;
          const prevData = new Date(value).valueOf();
          const nextData = new Date(this.list.effective_utc_end_date).valueOf();
          return prevData <= nextData;
        },
      },
      effective_utc_end_date: {
        required,
        afterDate(value) {
          if (!this.list.effective_utc_start_date) return true;
          const nextData = new Date(value).valueOf();
          const prevData = new Date(this.list.effective_utc_start_date).valueOf();
          return prevData <= nextData;
        },
      },
    },
    editedItem: {
      on_behalf_staff_uuid: {
        required,
      },
      function_uuid: {
        required,
      },
      // button_uuid: {
      //   required,
      // },
    },
  },
};
</script>

<style scoped>
.tableBoxComponent
  /deep/
  .v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  padding: 8px 16px;
}
</style>
